import React from 'react'
import './App.css'
import Routing from './Routes/Routing'

function App() {

  return (
    <div>
         <Routing />
    </div>
  )
}

export default App
